"use client";

import { WHATSAPP_MESSAGE, WHATSAPP_NUMBER, whatsappUrl } from "@/lib/whatsapp";
import { trackOaiq } from "@/lib/openai-pixel";

// Bulle ronde ouvrant une conversation WhatsApp avec un premier message
// pré-rempli. Rendue à gauche de la pastille "Réserver" (voir
// CalFloatingButton), mêmes couleurs. Le clic compte comme lead_created
// (conversion secondaire) dans le pixel ChatGPT Ads.
export function WhatsappBubble() {
  if (!WHATSAPP_NUMBER) return null;
  return (
    <a
      href={whatsappUrl(WHATSAPP_MESSAGE)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackOaiq("lead_created", { type: "customer_action" })}
      aria-label="Écrire sur WhatsApp"
      title="Écrire sur WhatsApp"
      className="inline-flex h-[52px] w-[52px] items-center justify-center rounded-full border border-paper/20 bg-navy text-paper shadow-2xl shadow-navy/40 transition-all duration-300 hover:border-gold hover:bg-gold hover:text-navy focus:outline-none focus:ring-2 focus:ring-gold focus:ring-offset-2 focus:ring-offset-background"
    >
      <svg viewBox="0 0 24 24" className="h-6 w-6" fill="currentColor" aria-hidden>
        <path d="M17.47 14.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.26-.46-2.39-1.48-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.6.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.61-.92-2.21-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.08 1.75-.72 2-1.41.25-.69.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35zM12.05 21.5h-.01a9.4 9.4 0 0 1-4.8-1.31l-.34-.2-3.57.93.95-3.48-.22-.36a9.4 9.4 0 0 1-1.44-5.01c0-5.2 4.23-9.43 9.44-9.43 2.52 0 4.89.98 6.67 2.77a9.37 9.37 0 0 1 2.76 6.67c0 5.2-4.23 9.43-9.44 9.43zm8.03-17.46A11.27 11.27 0 0 0 12.05.72C5.8.72.71 5.8.7 12.05c0 2 .52 3.95 1.52 5.66L.6 23.28l5.7-1.5a11.3 11.3 0 0 0 5.41 1.38h.01c6.25 0 11.34-5.09 11.34-11.34 0-3.03-1.18-5.88-3.32-8.02z" />
      </svg>
    </a>
  );
}
